var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-multiselect',{attrs:{"options":{
            options: _vm.options,
            label: 'name',
            trackBy: 'key',
            multiple: false,
            searchable: false
            },"id":_vm.id},scopedSlots:_vm._u([{key:"singleOption",fn:function({ option }){return [_c('img',{staticStyle:{"margin-right":"5px"},attrs:{"height":"20","src":`/imgs/icons/${option.key}.png`,"alt":"flag"}})]}},{key:"option",fn:function({ option }){return [_c('img',{staticStyle:{"margin-right":"5px"},attrs:{"height":"20","src":`/imgs/icons/${option.key}.png`,"alt":"flag"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(option.name))])]}}]),model:{value:(_vm.currentLanguage),callback:function ($$v) {_vm.currentLanguage=$$v},expression:"currentLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }